import { isAxiosError } from 'axios';

// API errors for this page are returned in Georgian, so they can be shown as-is.
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (!isAxiosError(err)) {
    return fallback;
  }
  if (err.response?.status === 413) {
    return 'ფაილის ზომა არ უნდა აღემატებოდეს 5MB-ს';
  }
  const message = (err.response?.data as { message?: unknown } | undefined)?.message;
  return typeof message === 'string' && message.trim() !== '' ? message : fallback;
};

// For requests made with responseType: 'blob', where the JSON error body arrives as a Blob.
export const getApiBlobErrorMessage = async (err: unknown, fallback: string): Promise<string> => {
  if (isAxiosError(err) && err.response?.data instanceof Blob) {
    try {
      const body = JSON.parse(await err.response.data.text()) as { message?: unknown };
      if (typeof body.message === 'string' && body.message.trim() !== '') {
        return body.message;
      }
    } catch {
      return fallback;
    }
  }
  return getApiErrorMessage(err, fallback);
};
